<app-dialog
  [visible]="visible"
  [showHeader]="false"
  [width]="'1200px'"
  [closable]="true"
  [overlayZIndex]="99999"
  (visibleChange)="visibleChange.emit($event)">
  <ng-container ngProjectAs="header">
    <div class="modal-header">
      <div class="modal-header__title-block">
        <span class="modal-eyebrow">{{ "UPLOADED_GEO_IMAGES.MODAL_EYEBROW" | translate }}</span>
        <span class="modal-title">{{ "UPLOADED_GEO_IMAGES.MODAL_TITLE" | translate }}</span>
      </div>
      <button
        class="modal-close-btn"
        (click)="handleCancel()"
        type="button">
        <i class="pi pi-times"></i>
      </button>
    </div>
    <div
      class="modal-summary"
      *ngIf="cards.length > 0">
      <span>{{ selectedCount }} {{ "UPLOADED_GEO_IMAGES.MODAL_OF" | translate }} {{ cards.length }} {{ "UPLOADED_GEO_IMAGES.MODAL_SELECTED" | translate }}</span>
      <span class="modal-summary__size">{{ selectedTotalSizeMb }} {{ "UPLOADED_GEO_IMAGES.MODAL_SIZE_UNIT" | translate }}</span>
      <app-secondary-button
        size="small"
        [title]="'UPLOADED_GEO_IMAGES.UPLOAD_BUTTON' | translate"
        (action)="triggerFileSelect()"></app-secondary-button>
    </div>
  </ng-container>

  <ng-container ngProjectAs="content">
    <div class="modal-body">
      <input
        type="file"
        #fileInput
        class="file-input"
        accept="image/*,.tif,.tiff"
        multiple
        (change)="onFileInputChange($event)" />

      <ng-container *ngIf="cards.length === 0; else cardsMode">
        <app-file-dropzone
          [accept]="'image/*,.tif,.tiff'"
          dragLabelKey="UPLOADED_GEO_IMAGES.MODAL_FILE_DRAG"
          hintLabelKey="UPLOADED_GEO_IMAGES.MODAL_FILE_HINT"
          buttonLabelKey="UPLOADED_GEO_IMAGES.MODAL_FILE_BUTTON"
          limitLabelKey="UPLOADED_GEO_IMAGES.MODAL_FILE_LIMIT_MULTIPLE"
          (filesSelected)="onFilesSelected($event)"></app-file-dropzone>
      </ng-container>

      <ng-template #cardsMode>
        <div class="cards-toolbar">
          <app-checkbox
            [label]="'UPLOADED_GEO_IMAGES.MODAL_SELECT_ALL' | translate"
            [ngModel]="allSelectableChecked"
            (ngModelChange)="toggleSelectAll($event)"></app-checkbox>
        </div>

        <section class="cards-container">
          <div class="cards-list">
            <app-geo-image-upload-card
              *ngFor="let card of cards; let i = index; trackBy: trackByCard"
              [card]="card"
              [showApplyAll]="i === 0 && cards.length > 1"
              (remove)="removeCard(i)"
              (applyAll)="applyFirstCardToAll()"
              (cardChange)="onCardChange(i, $event)"
              (enterCoordinates)="openCoordinateModal(i)"></app-geo-image-upload-card>

            <div
              class="file-card file-card--add-new"
              (click)="triggerFileSelect($event)">
              <div class="add-icon"><i class="pi pi-plus"></i></div>
              <div class="add-text">{{ "UPLOADED_GEO_IMAGES.MODAL_FILE_ADD_MORE" | translate }}</div>
            </div>
          </div>
        </section>
      </ng-template>

      <div
        class="form-errors"
        *ngIf="errors.length">
        <span *ngFor="let error of errors">{{ error | translate }}</span>
      </div>
    </div>
  </ng-container>

  <ng-container ngProjectAs="footer">
    <div class="modal-footer">
      <app-secondary-button
        [width]="'160px'"
        [title]="'UPLOADED_GEO_IMAGES.MODAL_CANCEL' | translate"
        (action)="handleCancel()"></app-secondary-button>
      <app-primary-button
        [width]="'160px'"
        [disable]="isProcessing || selectedCount === 0 || hasAnyStillChecking"
        [loading]="isProcessing"
        [title]="'UPLOADED_GEO_IMAGES.MODAL_START_PROCESSING' | translate"
        (action)="handleStartProcessing()"></app-primary-button>
    </div>
  </ng-container>

  <p-toast></p-toast>
</app-dialog>

<app-geo-image-coordinate-modal
  [visible]="coordinateModalVisible"
  (visibleChange)="coordinateModalVisible = $event"
  (confirmed)="onCoordinatesConfirmed($event)"></app-geo-image-coordinate-modal>
